import React, { useMemo } from 'react';
import { useRefinementList, useInstantSearch } from 'react-instantsearch';
import { usePrevious } from 'react-use';

import ColorsFilter from 'components/essentials/ColorsFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import MobileProductFilterWrapper from './MobileProductFilterWrapper';

/**
 * Color filter for mobile search filters modal.
 * Same logic as desktop (Algolia option_color + context selectedColors/selectColor),
 * compact display (grid like category page).
 */
const MobileProductListingColorFilter = () => {
  const { items: colorFilters } = useRefinementList({
    attribute: 'option_color',
  });
  const { results } = useInstantSearch();
  const { selectedColors, selectColor } = useAdvancedSearchContext();
  const colors = useMemo(
    () => colorFilters?.map(({ label }) => label?.toLowerCase()) ?? [],
    [colorFilters]
  );
  const previousColors = usePrevious(colors);

  const displayColors = useMemo(() => {
    if (colors.length) {
      return colors;
    }
    if (results?.nbHits === 0) {
      return [];
    }
    return previousColors ?? [];
  }, [colors, results?.nbHits, previousColors]);

  if (!displayColors?.length) {
    return null;
  }

  return (
    <MobileProductFilterWrapper id="color" label="Color">
      <ColorsFilter
        colors={displayColors}
        onSelectColor={selectColor}
        selectedColors={selectedColors}
        showAsTwoRows
      />
    </MobileProductFilterWrapper>
  );
};

export default MobileProductListingColorFilter;
